var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWork = function SvgWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5,
    d: "M27.087 46.667c1.48 5.75 6.7 10 12.913 10s11.433-4.25 12.913-10M36.726 9.213 14.118 26.797c-1.511 1.175-2.267 1.763-2.811 2.5a6.7 6.7 0 0 0-1.06 2.166C10 32.346 10 33.304 10 35.218v24.116c0 3.734 0 5.6.727 7.027a6.67 6.67 0 0 0 2.913 2.913c1.426.727 3.293.727 7.027.727h38.666c3.734 0 5.6 0 7.027-.727a6.67 6.67 0 0 0 2.913-2.913C70 64.934 70 63.067 70 59.333V35.217c0-1.915 0-2.872-.247-3.753a6.7 6.7 0 0 0-1.06-2.168c-.544-.736-1.3-1.323-2.811-2.499L43.274 9.213c-1.17-.91-1.756-1.366-2.403-1.541a3.33 3.33 0 0 0-1.742 0c-.647.175-1.232.63-2.403 1.541"
  })));
};
export default SvgWork;